
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"3.75","cy":"2.063","r":"1.5","fill":"#748190"}}),_c('circle',{attrs:{"cx":"3.75","cy":"7.313","r":"1.5","fill":"#748190"}}),_c('circle',{attrs:{"cx":"3.75","cy":"12.563","r":"1.5","fill":"#748190"}}),_c('circle',{attrs:{"cx":"10.25","cy":"2.063","r":"1.5","fill":"#748190"}}),_c('circle',{attrs:{"cx":"10.25","cy":"7.313","r":"1.5","fill":"#748190"}}),_c('circle',{attrs:{"cx":"10.25","cy":"12.563","r":"1.5","fill":"#748190"}})])
          )
        }
      }
    